export const pages = {
	'boltHome': { id: 'boltHome', page: 'home', getter: () => import(/* webpackChunkName: 'home' */ 'components/bolt/home/home') }
};
export const sections = [
	{ id: 'boltFeaturedVideos', getter: () => import(/* webpackChunkName: "featuredVideos" */ 'components/bolt/featuredVideos/featuredVideos'), component: 'featuredVideos', parent: 'boltHome' }
];
import VideoOverlayLoader from 'components/bolt/videoOverlayLoader/videoOverlayLoader';
export { VideoOverlayLoader };
